import {
  extractNftBatchTokenIds,
  nftBatchSizeOf,
} from "../../shared/nftAcquisitionLedger.js";

export { extractNftBatchTokenIds, nftBatchSizeOf };

export function formatNftBatchTokenPreview(tokenIds = [], { visible = 4 } = {}) {
  const ids = [
    ...new Set(
      (Array.isArray(tokenIds) ? tokenIds : [])
        .map((id) => String(id || "").replace(/^#/, "").trim())
        .filter(Boolean)
    ),
  ];
  if (!ids.length) return "";
  const shown = ids.slice(0, visible).map((id) => `#${id}`);
  const extra = ids.length - shown.length;
  return extra > 0 ? `${shown.join(" · ")} … +${extra}` : shown.join(" · ");
}

export function nftBatchDisplayMeta(tx = {}) {
  const ids = extractNftBatchTokenIds(tx);
  const size = nftBatchSizeOf(tx);
  const isBatch = size > 1 || ids.length > 1;
  return {
    isBatch,
    batchSize: isBatch ? size || ids.length : 0,
    tokenIds: ids,
    preview: formatNftBatchTokenPreview(ids),
  };
}
